import { useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();
  
  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-8">
          <h1 className="absolute bottom-0 text-9xl md:text-[20rem] font-red text-red-200 select-none pointer-events-none z-0">
        404
      </h1>
     
    </div>
  );
}